import loadCopyPasteCommands from './copy-paste';

export default (editor) => {
  loadCopyPasteCommands(editor);
}
